var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"myChart",staticStyle:{"width":"100%","height":"90%","position":"absolute","left":"50%","top":"50%","transform":"translate(-50%,-50%)"},attrs:{"id":"charts3"}})
}
var staticRenderFns = []

export { render, staticRenderFns }